import React from 'react';
import styled from 'styled-components';

const StaticField = ({ label, value }) => {
    return (
      <Wrapper>
        <Label>{label}:</Label>
        <Value>{value || '—'}</Value>
      </Wrapper>
    );
};

export default StaticField;

const Wrapper = styled.div`
  display: block;
  min-width: 0;
  padding: 4px 0;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
  line-height: 1.6;
`;

const Label = styled.span`
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--neutral-900);
  margin-right: 8px;
`;

const Value = styled.span`
  font-size: 0.9375rem;
  font-weight: 400;
  color: var(--neutral-800);
`;
